import { Dimensions, Platform } from 'react-native';

const getWindowWidth = () => Dimensions.get('window').width;

export const getScaledValue = (value: number) => value;

export const isPlatformWeb = Platform.OS === 'web';
export const isPlatformIos = Platform.OS === 'ios';
export const isPlatformMacos = Platform.OS === 'macos';
export const isPlatformTvos = Boolean(Platform.isTV);
export const isPlatformAndroidwear = false;

export const isWebBased = isPlatformWeb;
export const isFactorTv = Boolean(Platform.isTV);
export const isDesktop = isPlatformWeb && getWindowWidth() >= 980;
